import axios from "../instance";

export default {
  getAll: () => {
    return axios.api.get("/mDistricts").then((response) => response.data);
  },
  getOne: (id) => {
    return axios.api
      .get(`/mDistricts/${id}`)
      .then((response) => response.data);
  },
  search: (body) => {
    return axios.api
      .post("/mDistricts/search", body)
      .then((response) => response.data);
  },
  create: (body) => {
    return axios.api
      .post("/mDistricts", body)
      .then((response) => response.data);
  },
  update: (id, body) => {
    return axios.api
      .put(`/mDistricts/${id}`, body)
      .then((response) => response.data);
  },
  delete: (id) => {
    return axios.api
      .delete(`/mDistricts/${id}`)
      .then((response) => response.data);
  },
};
